export default __webpack_public_path__ + "static/mockup-cartoA4-df101fe3ca0e7038657ea30e175351ff.jpg";